export const iconFontAwesomeAccessibilityEarDeaf = (
	<i className="fa-solid fa-ear-deaf"></i>
);
